import { createContext } from "react"

export const ExamContext = createContext(null)

export const NewQuestionContext = createContext(null)

export const QuestionItemContext = createContext(null)

export const ValidatorContext = createContext(null)